import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

const getAuthHeader = () => {
  const rawToken = window.localStorage.getItem('token')
  if (!rawToken) {
    return {}
  }

  let token = rawToken

  try {
    token = JSON.parse(rawToken)
  } catch (error) {
    token = rawToken
  }

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
}

export const getMyInvite = async () => {
  try {
    const response = await axios.get(
      `${BASE_URL}users/me/invite`,
      getAuthHeader()
    )
    return response.data
  } catch (error) {
    console.error('Error fetching invite:', error)
    return null
  }
}

export const generateInvite = async () => {
  try {
    const response = await axios.post(
      `${BASE_URL}users/me/invite/generate`,
      {},
      getAuthHeader()
    )
    return response.data
  } catch (error) {
    console.error('Error generating invite:', error)
    return null
  }
}

export const validateInvite = async (inviteId) => {
  try {
    const response = await axios.get(`${BASE_URL}invites/${inviteId}`)
    return response.data
  } catch (error) {
    console.error('Error validating invite:', error)
    return null
  }
}

export const acceptInvite = async (inviteId, newUserId) => {
  try {
    const response = await axios.post(
      `${BASE_URL}invites/${inviteId}/accept`,
      { newUserId },
      getAuthHeader()
    )
    return response.data
  } catch (error) {
    console.error('Error accepting invite:', error)
    return null
  }
}

export const getInviteFromUrl = () => {
  const params = new URLSearchParams(window.location.search)
  return params.get('inviteId')
}
